const v2Companies = [
  '627f9df7bc69e77e98b40e6b',
  '644cfcd66b539eac404dbb58',
  '63ecb1dc0a5fb20c7c9885be',
  '6333ee35a65bfb4123a91d03',
  '642fffafd41b0c5ba94b6a05',
  '642a8d49cd4bec67aa67f99b',
  '6220ad68f436c48b5255c4aa',
  '63899e4033592bbaad6a179e',
  '62877e57c5175f9221402907',
  '627f31448d5ab105a60963c1',
  '62a9edf2b744a825dcbda755',
  '64306cd5d41b0c5ba94b846b',
  '643d9e7f6f71b5bdda286c5e',
  '6454dafcbd3fab4ec137ffd2',
  '643ef219336bb9fe9cc3771f',
  '64777d9572624d73a1b007b1',
  '647883cb483eaed16937b72f',
  '647d81db483eaed16938bd6b',
  '647e2e6f483eaed16938fd3f',
  '647e3295f131a7ba0d6b813f',
  '647f2729483eaed169393905',
  '647f3322f131a7ba0d6bc783',
  '647f3a59f131a7ba0d6bca90',
  '64949d414340d9e1ed790d0d',
  '6495f2fc483eaed1693da19f',
  '64a6a107f131a7ba0d73220e',
  '64b0dd8bdf33501f4c75f0d3',
  '64b0e1a07d787dde2609091b',
  '64b0e3a23543fe1bca328237',
  '64a5a2fb4340d9e1ed7be557',
  '64ce7450250bcfa4cf7b0da0',
  '64ec87dbee53e687a5f14981',
  '64eddd6b69364cb8ac0962ef',
  '64f61e44ec19a05f4a7d5148',
  '64f62d0d0615cccda60d2f14',
  '644fa7ddd83dae1da66cce28',
  '651855878423a3df7cf25768',
  '65294e589a73459579f3dbe5',
  '652c27aba11d9dcd16218b63',
  '652e3caa6028a5c45d2a4a91',
  '6550c15910222a6809d55214',
  '655120755d1ccb41f443b7b0',
  '65700f5ec23f0cf8dc1ac3e6',
  '65816faef16edd9a53637427',
  '6581c1d4f16edd9a53638a42',
  '65980adca373b1a29ee43c53',
  '65c3a839db745c7a8d26de28',
  '65dc96072936d8705bb669cf',
  '65e07139be6013a25edf71bb',
  '65e2d7725473a4dfd62db280',
  '65ec0d1dec6a616f99bc0a43',
  '65ef2463033167eb78499ca8',
  '65fc67e15452a249edec6268',
  '660bbabbfc702b271f0084e3',
  '66164b31a6039f2d6c6bd9fe',
  '6626574ea6039f2d6c7a6f8e',
  '662b9722a6039f2d6c7f7a36',
  '66338527a6039f2d6c866426',
  '664de2dd19551c534371b33a',
  '665894be19551c53437ccf35',
  '6658a3e419551c53437cef01',
  '66686041927748c6c3379dde',
  '667cf3b04c01c3f4c6610dd6',
  '669a66d3962d25814290b650',
  '66a0810c962d258142955eae',
  '66dd4c50a652cab8d6f012b4',
  '66e2d83fa652cab8d6f5eaa0',
  '656637266e190f3f7c4972a3',
  '6586ef090e2b29e43cf188d6',
  '662f30dba6039f2d6c8253f1',
  '6643049ad8304dd333c98a28',
  '66606fd419551c534385aaaf',
  '66dd44c4a652cab8d6f00ac2',
  '648a01364340d9e1ed774909',
  '64a0041f5d5a053d20f274c1',
  '64ce6e7e250bcfa4cf7b0d36',
  '65006322cb465910c5105a51',
  '64edbd75ee53e687a5f17131',
  '652e8bc4a11d9dcd1621dc33',
  '653956b8746bab3dc8ea010b',
  '65c3453eae275e2b786fedfe',
  '65c5e39d584b861f57cfd036',
  '65ef1e37033167eb78499ac9',
  '66ab0994962d2581429e87fe',
  '66b364ee962d258142a5d592',
  '66ba04533e2ebdf370ba402b',
  '66989fbe962d2581428ef6c0',
  '668be0ec4c01c3f4c66ec796',
  '66877d234c01c3f4c66b0139',
  '664de9c119551c534371bdda',
  '6630d262a6039f2d6c83ca10',
  '66005027ac438b17badeab95',
  '65f569f3a17588597c6a96ae',
  '65f5673ea17588597c6a9449',
  '671ab3de047ab70996a83969',
  '671ab26c047ab70996a83948',
  '664300b4d8304dd333c98680',
];

export const apiActionChooserSettings = {
  v2Enabled: true /* localStorage.getItem('v2Enabled') === 'true' */,
};

export const apiActionChooser = async (companyId, v1Action, v2Action) => {
  const useV2Api = true;

  // if (companyId && v2Companies.includes(companyId)) {
  //   useV2Api = true;
  // }

  if (useV2Api) {
    // console.log('Calling V2 API');
    await v2Action();
  } else {
    // console.warn('Calling V1 API');
    await v1Action();
  }
};

export const isCompanyAllowedForV2 = () => {
  return true;
  // const companyId = localStorage.getItem('v2-company-id');

  // return companyId && v2Companies.includes(companyId);
};

export const isCompanyAllowedForV2ById = (companyId) => {
  return true;
  // return companyId && v2Companies.includes(companyId);
};
